import { Col, Row } from '@wyz/ui';
import { PlatformLogo, Section } from '~/common/components';

import { ReactNode } from 'react';

const ErrorLayout = ({ children }: { children?: ReactNode }) => {
  return (
    <Section className='py-0'>
      <Row className='flex-center py-6'>
        <Col sm={11} md={9} lg={7} xl={6} className='col-xxl-5'>
          <PlatformLogo />
          {children}
        </Col>
      </Row>
    </Section>
  );
};

export default ErrorLayout;
